import { FC } from 'react';
import cn from 'classnames';

import { ErrorMessage } from '@/components/forms/ErrorMessage';

import { InputBoxProps } from './InputBox.props';

export const InputBox: FC<InputBoxProps> = ({
  isNecessary = true,
  label = 'Label',
  className,
  order = 1,
  errorMsg,
  children,
}) => {
  return (
    <label
      className={cn(
        'dark:focus-within:gray-scale-red relative flex h-full flex-col justify-between focus-within:text-accentMain',
        className,
        {
          'text-accentMain': errorMsg,
        },
      )}
    >
      <span className="relative text-lg">
        <span className="absolute top-0 w-max">
          {order ? `/0${order}` : '/01'}
        </span>
        <p className="whitespace-pre-wrap pl-[72px]">
          {label}
          {isNecessary && <span>*</span>}
        </p>
      </span>
      {children}
      {errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>}
    </label>
  );
};
